import { useTranslation } from 'react-i18next'
import { StyledButton } from './styled'

interface ButtonProps {
  text?: string
  style?: React.CSSProperties
  handleClick: () => void
}

const Button: React.FC<ButtonProps> = ({ text, style, handleClick }) => {
  const { t } = useTranslation()
  const textLabel = text ?? t('ok')

  return (
    <StyledButton style={style} onClick={handleClick}>
      {textLabel}
    </StyledButton>
  )
}

export default Button
